import { createApp } from 'vue';
import App from './App';
import locales from './locales';
import router from './router';
import store from './store';
import Helpers from './plugins/helpers';
import emitterPlugin from './plugins/emitter';
import setupPrimevue from './setupPrimevue';
import setupComponents from './setupComponents';
import { maska } from 'maska';
import abilityPlugin, { ability } from './plugins/ability';
import setupPermissionCheck from './setupPermissionCheck';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import * as Sentry from '@sentry/browser';

const app = createApp(App);
app.config.globalProperties.$locales = locales;
app.config.errorHandler = (error, _, info) => {
  console.error(error);
  Sentry.setTag('info', info);
  Sentry.captureException(error);
};

Sentry.init({
  release: `web-farm-client@${process.env.PACKAGE_VERSION}`,
  dsn: 'https://a9561d009c16401f886ad5bc1279909f@o551595.ingest.sentry.io/5675338',
  enabled: process.env.NODE_ENV === 'production',
  environment: process.env.NODE_ENV,
  tracesSampleRate: 0.5,
});

if (process.env.NODE_ENV === 'production') {
  app.use(VueReCaptcha, {
    siteKey: '6Lc3VzwaAAAAACHMwXtLjjimPBrsOS6CvuLARLmJ',
    loaderOptions: {
      autoHideBadge: true
    },
  });
}

app.use(router);
app.use(store);
app.use(Helpers);
app.use(emitterPlugin);
app.use(abilityPlugin);
app.directive('mask', maska);

setupPrimevue(app);
setupComponents(app);
setupPermissionCheck(router, ability);

app.mount('#app');
